import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-header-breadcrumb"
}
const _hoisted_2 = { class: "p-the-header-breadcrumb__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbLink = _resolveComponent("BreadcrumbLink")!

  return (_ctx.internalBreadcrumb.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internalBreadcrumb, ({ url, text, pageType }, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "p-the-header-breadcrumb__list__item",
              key: key
            }, [
              _createVNode(_component_BreadcrumbLink, {
                url: url,
                "last-element": key === _ctx.lastElementKey,
                text: text,
                "page-type": pageType,
                "item-key": key
              }, null, 8, ["url", "last-element", "text", "page-type", "item-key"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}